import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Icon, Text } from '@landtrustinc/design-system';

/** "No credit card required" reassurance shown under the inquiry submit button. */
const InquiryNoCreditCardNote = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    gap="var(--spacing-2)"
    color="var(--color-hunter-500)"
    data-testid="inquiry-no-credit-card"
  >
    <Icon variant="ShieldCheck" size="small" />
    <Text as="span" size="sm" fontWeight="semibold" color="var(--color-hunter-500)">
      <FormattedMessage id="InquiryWizard.noCreditCardRequired" />
    </Text>
  </Box>
);

export default InquiryNoCreditCardNote;
